export default __webpack_public_path__ + "static/media/fire1.e362263f.png";